<template>
  <div class="row">
    <div class="col-xs-12">
      <h3>
        {{ title }}
      </h3>
    </div>
    <div
      class="col-xs-12 col-sm-6 col-md-4"
      v-for="candidato in listaCandidatos"
      :key="`pornumero-${candidato.numero}`"
    >
      <ProgressoGeral
        :candidato="candidato"
        :perc="((candidato.total_votos / votosNominaisTotais) * 100).toFixed(2)"
      />
    </div>
  </div>
</template>

<script>
import ProgressoGeral from './ProgressoGeral.vue'

export default {
  components: { ProgressoGeral },
  props: {
    title: {
      type: String,
      default: 'Resultado Geral'
    },
    listaCandidatos: {
      type: Array,
      required: true
    },
    votosNominaisTotais: {
      type: Number,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EleicaoConselho/ListaCandidatosGeral.vue